// extracted by mini-css-extract-plugin
export default {"collapseAnimationTimeout":"250"};